import classNames from "classnames";
import React, { type PropsWithChildren } from "react";
import { useTranslationContext } from "../../../Blocks/ProvetOnlineBooking/context";
import { Svg, SvgSize } from "../../Assets/Svg/React";

interface PopOverProps {
  id: string;
  anchorId: string;
  title: string;
}

export const Popover = ({
  anchorId,
  id,
  children,
  title
}: PropsWithChildren<PopOverProps>) => {
  const translationContext = useTranslationContext();

  return (
    <div
      className={classNames(
        "absolute z-component flex flex-col transition-[transform,opacity] transition-short-in",
        "inert:opacity-0 inert:-translate-y-xl inert:transition-short-out",
        "min-w-[16.6875rem] md:min-w-[22.875rem]"
      )}
      data-anchor-element-id={anchorId}
      data-popover
      data-position-x="middle"
      data-position-y="above"
      id={id}
      {...{ inert: "" }}
      role="region"
      aria-label={title}
    >
      <div className="p-md rounded-md bg-neutral-0 shadow-sm">
        <div className="relative">
          <div data-popover-content tabIndex={-1}>
            {children}
          </div>

          <button
            className="absolute top-0 right-0 text-t-md text-dark-blue focus-outline transition-short-in-out"
            id={`${id}-close-button`}
            title={translationContext?.translations?.close}
          >
            <Svg href="/svg/system/close.svg" />
          </button>
        </div>
      </div>

      <Svg
        href="/svg/tip-vector.svg"
        additionalClass="relative w-[1.25rem] h-[0.75rem] text-neutral-0 self-center rotate-180"
        size={SvgSize.Custom}
      />
    </div>
  );
};
